import { render, staticRenderFns } from "./ddpc.vue?vue&type=template&id=56348382&scoped=true&"
import script from "./ddpc.vue?vue&type=script&lang=js&"
export * from "./ddpc.vue?vue&type=script&lang=js&"
import style0 from "./ddpc.vue?vue&type=style&index=0&id=56348382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56348382",
  null
  
)

export default component.exports